import styled from "styled-components";

export const LanguageBaseWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
  .fui-AccordionPanel {
    padding: 0px 8px 16px 8px;
    .fui-Dropdown {
      width: 100%;
    }
  }
  .btn-group {
    margin-top: 10px;
    border-top: 1px solid #bdbdbd;
    display: flex;
    justify-content: flex-end;
    /* padding-bottom: 10px; */

    button {
      margin-top: 10px;
      margin-left: 10px;
      background-color: #106ebe;
      color: #fff;
      min-width: 0 !important;

      &:first-child {
        background-color: transparent;
        border: unset;
        color: #106ebe;
        text-decoration: underline;
      }
    }
  }
  .rf-settings-button-apply {
    margin-top: 8px;
    text-decoration: underline;
    color: #106ebe;
    font-size: 14px;
    font-weight: 400;

    &:hover {
      cursor: pointer;
    }

    &:last-child {
      margin-left: 10px;
      background-color: #106ebe;
      color: #fff;
      text-decoration: unset;
      padding: 5px 20px;
      border-radius: 3px;
    }
  }
`;

export const LanguageContentBaseWrapper = styled.div<{ $theme?: string }>`
  padding: 0px;
  border-top: 1px solid #bababa;
`;

export const LanguageContentRowBaseWrapper = styled.div<{ $theme?: string }>`
  margin-top: 10px;
  .search-box-try {
    width: 100%;
  }
`;
